<template>
  <v-card title="Teams">
    <template v-slot:append>
      <v-icon icon="mdi-calendar-plus" @click="openModal('addBranchYearTeam')"></v-icon>
      <v-tooltip activator="parent" location="end">Add Team</v-tooltip>
    </template>
    <v-card-text>
      <v-data-table-server
        v-model="branchYearTeams.selected"
        :headers="branchYearTeams.headers"
        :items="branchYearTeams.data"
        :items-per-page="branchYearTeams.pageOptions.limit"
        item-key="id"
        :loading="branchYearTeams.loading"
        :items-length="branchYearTeams.count ?? 0"
        :search="branchYearTeams.pageOptions.q"
        @update:options="handleBranchYearTeamChange">
        <template v-slot:[`item.action`]="{ item }">
          <v-row justify="end">
            <v-col cols="auto">
              <router-link
                :to="{
                  name: 'AdminYearTeamDetailView',
                  params: { yearId: yearId, teamId: item.id },
                }">
                <v-icon icon="mdi-pencil">
                  <v-tooltip activator="parent" location="end">Edit Team</v-tooltip>
                </v-icon></router-link
              > </v-col
            ><v-col cols="auto/">
              <div @click="openModal('removeBranchYearTeam', item)">
                <v-icon color="error">mdi-delete </v-icon>
                <v-tooltip activator="parent" location="end">Remove Team</v-tooltip>
              </div>
            </v-col></v-row
          >
        </template>
        <template v-slot:top>
          <v-text-field
            v-model="branchYearTeams.pageOptions.q"
            class="ma-2"
            density="compact"
            placeholder="Search branch year..."
            hide-details></v-text-field>
        </template>
      </v-data-table-server>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { IPaginationDTO, PaginationDTO } from '@/dtos';
import { useBranchYearStore } from '@/stores/modules/admin';
import { computed, ref, toRef } from 'vue';
import type { VDataTableServer } from 'vuetify/components';
interface Props {
  branchId: string;
  yearId: string;
}
const props = defineProps<Props>();

const branchId = toRef(props, 'branchId', '');
const yearId = toRef(props, 'yearId', '');
//const emit = defineEmits(['snack']);
const pagination = ref<IPaginationDTO>(new PaginationDTO());

const branchYearStore = useBranchYearStore();
const { data: branchYearData, isLoading: isLoadingBranchYears } =
  branchYearStore.getBranchYearTeamsQuery(branchId, yearId, pagination);

const branchYearTeams = ref({
  pageOptions: pagination,
  count: computed(() => branchYearData.value?.count),
  data: computed(() => branchYearData.value?.data),
  loading: computed(() => isLoadingBranchYears.value),
  selected: [] as string[],
  headers: [
    { title: 'Team', key: 'name', align: 'start', sortable: true },
    {
      title: 'Level',
      key: 'orders[0].productVariant.product.teamLevel.team_level',
      align: 'start',
      sortable: true,
    },
    { title: '', key: 'action', align: 'end', sortable: false },
  ] as const,
});

const openModal = (type: string, item = {}) => {
  if (type === 'addBranchYearTeam') {
    console.log('add');
  } else if (type == 'removeBranchYearTeam') {
    console.log('item', item);
  }
};

const handleBranchYearTeamChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};
</script>
